import { useContext, useEffect} from "react";
import { Button, Container, Row, Col } from 'react-bootstrap';
import { BiMailSend } from "react-icons/bi";
import ReclamoContext from "../../context/reclamo/reclamoContext";
import TokenContext from "../../context/Token/TokenContext";


const ReclamoEnviadoComponent = ({history}) => {
    
  const reclamoContext = useContext(ReclamoContext);
  const { reclamo_enviado, data_usuario, Reclamo_Enviado_F, Get_Temporales_F, resetReclamoF } = reclamoContext;
  const tokenContext = useContext(TokenContext);
  const { Active_Token_F, resetTokenF } = tokenContext;

  useEffect(() => {
    window.gtag('event', 'Fin de reclamo alza de precio base', {
      event_category : 'Reclamo por alza en planes de Isapres',
      event_label : 'Trámite - ID 0300520010'
    });
  }, [])

  const FinalizarClick = () => {
    localStorage.clear();
    Active_Token_F('')
    Get_Temporales_F([])
    resetTokenF()
    resetReclamoF()
    Reclamo_Enviado_F(false);
    window.location.href = "https://api.claveunica.gob.cl/api/v1/accounts/app/logout"
    history.push('/');
  }

  const RedirectPortal = () => {

    window.location.href = "https://misuper.superdesalud.gob.cl/"
    Reclamo_Enviado_F(false);

  }
    return (  

        <Container fluid>
            <Row className='mx-auto recibido-ss'>
                
                <div className="div-icon-ss mt-5">
                    <BiMailSend className="icon-ss"/>
                </div>

                <Col md="12" className="text-center "><h5 className="font-primary-ss font-weight-bold">Reclamo Recibido</h5></Col>

                <Col md="12" className=" "><p>¡Su reclamo ha sido recibido con éxito! Se ha generado 1 reclamo, su número de folio es:</p></Col>
                <Col md="12" className="  font-primary-ss"><p>{reclamo_enviado.folio}</p></Col>

                <Col md="12" className="  "><p>Le hemos enviado un correo de confirmación a: </p></Col>
                <Col md="12" className=" font-primary-ss text-center"><p>{data_usuario.email}</p></Col>

                <Button className="d-flex mx-auto btn-primary-ss px-5 mb-5" onClick={() => RedirectPortal()}>Ir a Mi Portal</Button>
                <Button className="d-flex mx-auto btn-primary-ss px-5 mb-5" onClick={() => FinalizarClick()}>Finalizar</Button>


            </Row>
        </Container>

    );
}
 
export default ReclamoEnviadoComponent;